import { render, staticRenderFns } from "./SearchAddIcon.vue?vue&type=template&id=57ec005e"
import script from "./SearchAddIcon.vue?vue&type=script&lang=js"
export * from "./SearchAddIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports